import { ValidationOperation } from '../../../validation/validator';
import {
    EventEntityTableName,
    RecordByEventEntityTable,
    ModelByEventEntityTable,
} from '../../../../types/Events';

export const mapRawRecord = <K extends EventEntityTableName>(
    record: ModelByEventEntityTable[K],
) => {
    return record._raw as unknown as RecordByEventEntityTable[K];
};

export const mapRawRecords = <K extends EventEntityTableName>(
    records: ModelByEventEntityTable[K][],
) => {
    return records.map((record) => mapRawRecord<K>(record));
};

export const mapRecords = <K extends EventEntityTableName>(
    records: ModelByEventEntityTable[K][],
    table: K,
    operation: ValidationOperation,
) => {
    return records.map((record) => ({
        record,
        table,
        operation,
    }));
};
